export default __webpack_public_path__ + "static/media/nouser.96156881.png";